import { render, staticRenderFns } from "./PstQuery.vue?vue&type=template&id=0c22f8c4&scoped=true&"
import script from "./PstQuery.vue?vue&type=script&lang=js&"
export * from "./PstQuery.vue?vue&type=script&lang=js&"
import style0 from "./PstQuery.vue?vue&type=style&index=0&id=0c22f8c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22f8c4",
  null
  
)

export default component.exports